/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignUpWithPhoneFirebase
 */
export interface SignUpWithPhoneFirebase {
    /**
     * 
     * @type {string}
     * @memberof SignUpWithPhoneFirebase
     */
    firebaseIdToken: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpWithPhoneFirebase
     */
    password: string;
}

/**
 * Check if a given object implements the SignUpWithPhoneFirebase interface.
 */
export function instanceOfSignUpWithPhoneFirebase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firebaseIdToken" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function SignUpWithPhoneFirebaseFromJSON(json: any): SignUpWithPhoneFirebase {
    return SignUpWithPhoneFirebaseFromJSONTyped(json, false);
}

export function SignUpWithPhoneFirebaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignUpWithPhoneFirebase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firebaseIdToken': json['firebaseIdToken'],
        'password': json['password'],
    };
}

export function SignUpWithPhoneFirebaseToJSON(value?: SignUpWithPhoneFirebase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firebaseIdToken': value.firebaseIdToken,
        'password': value.password,
    };
}

